export const smallDevice = '@media (max-width: 769px)';
export const largeDevice = '@media (min-width: 770px)';